<template>
  <vs-input
    ref="mlInput"
    :type="type"
    class="ml-input"
    v-model="inputValue"
    :readonly="readonly"
    :disabled="disabled"
    :placeholder="_placeholder"
    :icon-pack="iconPack"
    :icon="icon"
    :max="maxValue"
    :min="minValue"
    @keyup="(e) => handleKeyup(e)"
    @click="(e) => $emit('click', e)"
    @focusout="(e) => $emit('focusout', e)"
    @blur="(e) => $emit('blur', e, inputValue)"
  />
</template>

<script>
export default {
  name: "MaxLengthInput",
  props: {
    type: { type: String, default: "text" },
    value: { type: String | Number, default: "" },
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    max: { type: Number, default: 200 },
    iconPack: String,
    icon: String,
    noneCount: String,
    minValue: Number,
    maxValue: Number,
    renderFocus: Boolean,
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
    inputValue: {
      immediate: true,
      deep: true,
      handler(value) {
        // value에서 noneCount 문자를 모두 제거
        if (!!this.noneCount) value = value.replaceAll(this.noneCount, "");

        if (!!value && value.length > this.max) {
          this.inputValue = this.value;
          alert(`${this.max}자까지 작성할 수 있습니다.`);
          // this.$refs.mlInput.focus();
        } else {
          this.$emit("input", value);
          this.$emit("change", value);
        }
      },
    },
  },
  computed: {
    _placeholder() {
      if (this.placeholder) return this.placeholder;

      if (this.type === 'tel') return '***-****-****';
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.renderFocus) this.$refs.mlInput.focusInput();
    });
  },
  methods: {
    handleKeyup(value) {
      if (this.type === 'tel') {
        this.$emit('input', this.getTelMask(value));
      }
      this.$emit('keyup', value)
    },

    getTelMask (event) {
      let value = event.target.value
      if (!value) return value
      value = value.replace(/[^0-9]/g, '')

      let res = ''
      if (value.substring(0, 2) =='02') {
        if (value.length < 3) {
          res = value
        } else if (value.length <= 5) {
          res = value.replace(/(\d{2})(\d{0,3})/, '$1-$2')
        } else if(value.length <= 9) {
          res = value.replace(/(\d{2})(\d{0,3})(\d{0,4})/, '$1-$2-$3')
        } else {
          res = value.replace(/(\d{2})(\d{0,4})(\d{0,4})/, '$1-$2-$3')
        }
        res = res.substring(0, 12)
      } else {
        if (value.length < 4) {
          res = value
        } else if(value.length <= 6) {
          res = value.replace(/(\d{3})(\d{0,3})/, '$1-$2')
        } else if(value.length <= 10) {
          res = value.replace(/(\d{3})(\d{0,3})(\d{0,4})/, '$1-$2-$3')
        } else {
          res = value.replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1-$2-$3')
        }
        res = res.substring(0, 13)
      }
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
.ml-input::v-deep {
  .input-span-placeholder {
    line-height: 1.2rem;
  }
}
</style>
